import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue"
import _imports_0 from 'assets/katsu/bonus-code.svg'
import _imports_1 from 'assets/katsu/ask.png'
import _imports_2 from 'assets/katsu/cashout.png'
import _imports_3 from 'assets/katsu/guru.png'
import _imports_4 from 'assets/images/promo/money.png'
import _imports_5 from 'assets/images/promo/box.png'
import _imports_6 from 'assets/images/promo/smille.png'
import _imports_7 from 'assets/katsu/modern-promo/providers/gameart.svg'
import _imports_8 from 'assets/katsu/modern-promo/providers/yggdrasil.svg'
import _imports_9 from 'assets/katsu/modern-promo/providers/1x2gaming.svg'
import _imports_10 from 'assets/katsu/modern-promo/providers/belatra.svg'
import _imports_11 from 'assets/katsu/modern-promo/providers/playngo.svg'
import _imports_12 from 'assets/katsu/modern-promo/providers/nettent.svg'
import _imports_13 from 'assets/katsu/modern-promo/providers/bgaming.svg'
import _imports_14 from 'assets/katsu/modern-promo/providers/wazdan.svg'
import _imports_15 from 'assets/katsu/modern-promo/providers/platipus.svg'
import _imports_16 from 'assets/katsu/modern-promo/providers/pragmaticplay.svg'
import _imports_17 from 'assets/katsu/modern-promo/providers/redtiger.svg'
import _imports_18 from 'assets/katsu/modern-promo/providers/betsoft.svg'
import _imports_19 from 'assets/katsu/modern-promo/providers/boming.svg'
import _imports_20 from 'assets/katsu/modern-promo/providers/2by2.svg'
import _imports_21 from 'assets/katsu/modern-promo/payments/visa.svg'
import _imports_22 from 'assets/katsu/modern-promo/payments/mastercard.svg'
import _imports_23 from 'assets/katsu/modern-promo/payments/maestro.svg'
import _imports_24 from 'assets/katsu/modern-promo/payments/skrill.svg'
import _imports_25 from 'assets/katsu/modern-promo/payments/rapid.svg'
import _imports_26 from 'assets/katsu/modern-promo/payments/netteller.svg'
import _imports_27 from 'assets/katsu/modern-promo/payments/neoserf.svg'
import _imports_28 from 'assets/katsu/modern-promo/payments/interac-online.svg'
import _imports_29 from 'assets/katsu/modern-promo/payments/alfa.svg'
import _imports_30 from 'assets/katsu/modern-promo/payments/interac-e.svg'
import _imports_31 from 'assets/katsu/modern-promo/payments/idebit.svg'
import _imports_32 from 'assets/katsu/modern-promo/payments/instadebit.svg'
import _imports_33 from 'assets/katsu/modern-promo/payments/paysafe.svg'
import _imports_34 from 'assets/katsu/modern-promo/payments/ecovoucher.svg'
import _imports_35 from 'assets/images/promo/copyright.png'


const _hoisted_1 = ["data-theme"]
const _hoisted_2 = {
  key: 0,
  autoplay: "",
  playsinline: "",
  loop: "",
  muted: "",
  preload: "auto",
  class: "modern-video-background"
}
const _hoisted_3 = ["src", "type"]
const _hoisted_4 = { class: "modern-head" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "katsubet-bonus-code katsubet-bonus-code-copied"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "katsubet-bonus-code-img",
  src: _imports_0,
  alt: "bonus-code"
}, null, -1)
const _hoisted_8 = {
  key: 3,
  class: "katsubet-bonus-code"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "katsubet-bonus-code-img",
  src: _imports_0,
  alt: "bonus-code"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" NO BONUS CODE ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "modern-label-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-label-icon__img",
    src: _imports_1,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-label-icon__img",
    src: _imports_2,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-label-icon__img",
    src: _imports_3,
    alt: "img"
  })
], -1)
const _hoisted_13 = { class: "modern-steper" }
const _hoisted_14 = { class: "modern-steper__block" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "modern-steper__img-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-steper__img",
    src: _imports_4,
    alt: "img"
  })
], -1)
const _hoisted_16 = { class: "modern-steper__label" }
const _hoisted_17 = { class: "modern-steper__block" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "modern-steper__img-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-steper__img",
    src: _imports_5,
    alt: "img"
  })
], -1)
const _hoisted_19 = { class: "modern-steper__label" }
const _hoisted_20 = { class: "modern-steper__block" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "modern-steper__img-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-steper__img",
    src: _imports_6,
    alt: "img"
  })
], -1)
const _hoisted_22 = { class: "modern-steper__label" }
const _hoisted_23 = { class: "modern-supplied" }
const _hoisted_24 = { class: "modern-supplied__title" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "modern-supplied__img-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_7,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_8,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_9,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_10,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_11,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_12,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_13,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_14,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_15,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_16,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_17,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_18,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_19,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_20,
    alt: "img"
  })
], -1)
const _hoisted_26 = { class: "modern-supplied modern-supplied__bottom" }
const _hoisted_27 = { class: "modern-supplied__title" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_21,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_22,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_23,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_24,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_25,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_26,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_27,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_28,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_29,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_30,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_31,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_32,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_33,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_34,
    alt: "img"
  })
], -1)
const _hoisted_29 = { class: "modern-footer" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  class: "modern-footer__img",
  src: _imports_35,
  alt: "copyright"
}, null, -1)
const _hoisted_31 = { class: "modern-footer__copyright" }

import { ref, toRefs, watch } from 'vue';
import { useCommonPromo } from '@/composables/useCommonPromo';
import Markdown from '@/components/markdown.vue';
import PromoPageRegHackForm from '@/components/promoPageRegHackForm.vue';
import { PromoPageInterface } from '~/types/promoPage.interface';
import { copyText } from '@/utils/vue3-clipboard2';


export default /*#__PURE__*/_defineComponent({
  props: {
    pageData: null
  },
  setup(__props: any) {

const props = __props as {
  pageData: PromoPageInterface;
}



const {
  dataPlatformAttr,
  theme,
  lang,
  targetHost,
  currency,
  videoBanner,
  promoLoader,
  logoImg,
  bannerCssVariables,
  onlyCrypto,
} = useCommonPromo(props);

const {
  bonus_code: bonusCode,
  first_step: firstStep,
  second_step: secondStep,
  third_step: thirdStep,
  first_title: firstTitle,
  second_title: secondTitle,
  third_title: thirdTitle,
  form_title: formTitle,
  form_button_text: formBtnText,
  form_text: formText,
  footer_text: footerText,
  copyright_text: copyrightText,
  footer_supplied_by: footerSuppliedBy,
  footer_payment_methods: footerPaymentMethods,
  first_step_label: firstStepLabel,
  second_step_label: secondStepLabel,
  third_step_label: thirdStepLabel,
} = toRefs(props.pageData.params[0]);

const isCopiyed = ref(false);

const copyToClipboard = async (text: string) => {
  try {
    await copyText(text);
    isCopiyed.value = true;
  } catch (e) {
    console.error(e);
  }
};

watch(
  () => isCopiyed.value,
  () => {
    if (isCopiyed.value) {
      window.setTimeout(() => {
        isCopiyed.value = false;
      }, 3000);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (__props.pageData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modern-container",
        "data-theme": _unref(theme)
      }, [
        _createElementVNode("div", _mergeProps({ class: "modern-wrapper" }, _unref(dataPlatformAttr), { style: _unref(bannerCssVariables) }), [
          (_unref(videoBanner) && !_ctx.renderTimeout)
            ? (_openBlock(), _createElementBlock("video", _hoisted_2, [
                _createElementVNode("source", {
                  src: _unref(videoBanner).url,
                  type: _unref(videoBanner).mime
                }, null, 8, _hoisted_3)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_unref(logoImg))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "modern-head__logo",
                  src: _unref(logoImg).url,
                  alt: "logo"
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(firstTitle),
              class: "title"
            }, null, 8, ["text"]),
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(secondTitle),
              class: "modern-head__title"
            }, null, 8, ["text"]),
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(thirdTitle),
              class: "modern-head__text"
            }, null, 8, ["text"]),
            (isCopiyed.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Copied! "))
              : (_unref(bonusCode))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "katsubet-bonus-code",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (copyToClipboard(_unref(bonusCode))))
                  }, [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_unref(bonusCode)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
          ]),
          _createVNode(PromoPageRegHackForm, {
            class: "modern-form",
            lang: _unref(lang),
            "form-title": _unref(formTitle),
            "form-btn-text": _unref(formBtnText),
            "form-text": _unref(formText),
            "promo-loader": _unref(promoLoader),
            "crypto-only": _unref(onlyCrypto),
            "preselected-currency": _unref(currency),
            "target-host": _unref(targetHost)
          }, null, 8, ["lang", "form-title", "form-btn-text", "form-text", "promo-loader", "crypto-only", "preselected-currency", "target-host"]),
          _hoisted_12
        ], 16),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h1", null, _toDisplayString(_unref(firstStepLabel)), 1),
              _createVNode(Markdown, {
                "auto-link-parse": false,
                text: _unref(firstStep),
                class: "modern-steper__center"
              }, null, 8, ["text"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h1", null, _toDisplayString(_unref(secondStepLabel)), 1),
              _createVNode(Markdown, {
                "auto-link-parse": false,
                text: _unref(secondStep),
                class: "modern-steper__center"
              }, null, 8, ["text"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("h1", null, _toDisplayString(_unref(thirdStepLabel)), 1),
              _createVNode(Markdown, {
                "auto-link-parse": false,
                text: _unref(thirdStep),
                class: "modern-steper__center"
              }, null, 8, ["text"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("h2", _hoisted_24, _toDisplayString(_unref(footerSuppliedBy)), 1),
          _hoisted_25
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("h2", _hoisted_27, _toDisplayString(_unref(footerPaymentMethods)), 1),
          _hoisted_28
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(footerText)
            }, null, 8, ["text"]),
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(copyrightText),
              class: "modern-footer__copyright modern-footer__copyright-text"
            }, null, 8, ["text"])
          ])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})